/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audiencenoteplaceholder2Inputs */

const en_audiencenoteplaceholder2 = /** @type {(inputs: Audiencenoteplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Bring your student ID`)
};

const de_audiencenoteplaceholder2 = /** @type {(inputs: Audiencenoteplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Studierendenausweis mitnehmen`)
};

/**
* | output |
* | --- |
* | "e.g. Bring your student ID" |
*
* @param {Audiencenoteplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const audiencenoteplaceholder2 = /** @type {((inputs?: Audiencenoteplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audiencenoteplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audiencenoteplaceholder2(inputs)
	return de_audiencenoteplaceholder2(inputs)
});
export { audiencenoteplaceholder2 as "audienceNotePlaceholder" }